import { getAccessToken } from "../utils";
import axios from "axios";
import { isRateLimitError } from "../utils/rateLimit";

// Create axios instance for interceptors
const axiosInstance = axios.create();

// Request interceptor to add security headers (CSRF protection & CORS compliance)
axiosInstance.interceptors.request.use(
  (config) => {
    // Add X-Requested-With header for CSRF protection
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    
    // Add Accept header for JSON responses (if not already set)
    if (!config.headers['Accept']) {
      config.headers['Accept'] = 'application/json';
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling rate limits globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 429 rate limit errors - let them pass through to be handled by ErrorHandler
    // Components will handle displaying rate limit messages
    if (isRateLimitError(error)) {
      // Error will be handled by ErrorHandler utility
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

class HttpService {
  constructor() {
    // this.token = getAccessToken();
    this.baseUrl = {
      APP_BASE_URL: process.env.REACT_APP_BASE_URL,
      CLOUDINARY: "https://api.cloudinary.com/v1_1/"
    };
   
  }

  postData = async (payload, url, services="APP_BASE_URL") => {
    const AuthStr = "Bearer ".concat(getAccessToken());
    return axiosInstance.post(`${this.baseUrl[`${services}`]}${url}`, payload, {
      headers: { Authorization: AuthStr },
    });
  };

  postDataWithoutToken = async (payload, url, services="APP_BASE_URL") => {
    return axiosInstance.post(`${this.baseUrl[`${services}`]}${url}`, payload);
  };

  postFormData = async (formData, url, services="APP_BASE_URL") => {
    const AuthStr = "Bearer ".concat(getAccessToken());
    return axiosInstance.post(`${this.baseUrl[`${services}`]}${url}`, formData, {
      headers: { 
        Authorization: AuthStr,
        'Content-Type': 'multipart/form-data',
      },
    });
  };
 

  getData = async (url, services="APP_BASE_URL") => {
    const AuthStr = "Bearer ".concat(getAccessToken());
    return axiosInstance.get(`${this.baseUrl[`${services}`]}${url}`, {
      headers: { Authorization: AuthStr },
    });
  };

  /** Authenticated GET returning raw blob (e.g. onboarding document download). */
  getBlob = async (url, services = "APP_BASE_URL") => {
    const AuthStr = "Bearer ".concat(getAccessToken());
    return axiosInstance.get(`${this.baseUrl[`${services}`]}${url}`, {
      headers: { Authorization: AuthStr },
      responseType: "blob",
    });
  };

  getDataWithoutToken = async (url, services="APP_BASE_URL") => {
    return axiosInstance.get(`${this.baseUrl[`${services}`]}${url}`);
  };

  putData = async (formData, url, services="APP_BASE_URL") => {
    const AuthStr = "Bearer ".concat(getAccessToken());
    return axiosInstance.put(`${this.baseUrl[`${services}`]}${url}`, formData, {
      headers: { Authorization: AuthStr },
    });
  };

  putDataWithoutToken = async (formData, url, services="APP_BASE_URL") => {
    return axiosInstance.put(`${this.baseUrl[`${services}`]}${url}`, formData);
  };

  deleteData = async (url, payload = null, services="APP_BASE_URL") => {
    const AuthStr = "Bearer ".concat(getAccessToken());
    const config = {
      headers: { Authorization: AuthStr },
    };
    
    if (payload) {
      config.data = payload;
    }
    
    return axiosInstance.delete(`${this.baseUrl[`${services}`]}${url}`, config);
  };
}
export default HttpService;
